// Generated by ReScript, PLEASE EDIT WITH CARE


function ticketStatusToString(status) {
  switch (status) {
    case "Waiting" :
      return "waiting";
    case "Served" :
      return "served";
    case "Expired" :
      return "expired";
    case "Discarded" :
      return "discarded";
  }
}

function ticketStatusFromString(str) {
  switch (str) {
    case "discarded" :
      return "Discarded";
    case "expired" :
      return "Expired";
    case "served" :
      return "Served";
    case "waiting" :
      return "Waiting";
    default:
      return;
  }
}

function servedByToString(servedBy) {
  if (servedBy === "Self") {
    return "self";
  } else {
    return "operator";
  }
}

function servedByFromString(str) {
  switch (str) {
    case "operator" :
      return "Operator";
    case "self" :
      return "Self";
    default:
      return;
  }
}

function getTicketStatus(ticket) {
  let status = ticketStatusFromString(ticket.status);
  if (status !== undefined) {
    return status;
  } else {
    return "Waiting";
  }
}

export {
  ticketStatusToString,
  ticketStatusFromString,
  servedByToString,
  servedByFromString,
  getTicketStatus,
}
/* No side effect */
